import PropTypes from 'prop-types'
import React from 'react'
import { TableBodyCell, TableRow, helpers } from 'react-wot-bootstrap'

import ButtonLeavingClan from 'components/ButtonLeavingClan/ButtonLeavingClan'

import { NotPlayedInClanModesTooltip, LeavingClanTooltip } from '../ClanManagement/tooltips'
import { NotEarnedResourceTooltip } from '../ClanManagement/EarnedResourceTooltip'

import BaseMembersTableItem from './BaseMembersTableItem'

class ClanModesMembersTableItem extends BaseMembersTableItem {
    renderBattleModeTableCell = battleModeName => {
        const battlesCount = this.props[battleModeName]
        return (
            <TableBodyCell
                valueType={battlesCount ? undefined : 'null'}
                valueWidth="45"
                isValue
                key={battleModeName}
                tooltipId={battlesCount ? 'battles-in-clan-tooltip' : NotPlayedInClanModesTooltip.id}
                tooltipTip={battlesCount ? `${battleModeName}-${this.props.memberId}` : undefined}
            >
                {helpers.thousands(battlesCount)}
            </TableBodyCell>
        )
    }

    renderExitFromClanButton = () => {
        if (this.props.isOwn === false || this.props.memberRole === 'commander') {
            return null
        }
        return (
            <ButtonLeavingClan
                tooltipId={LeavingClanTooltip.id}
            />
        )
    }

    render() {
        const ir =
            this.props.industrialResourceEarnedAsClanmate +
            this.props.industrialResourceEarnedAsLegionary +
            this.props.industrialResourceEarnedInRandomInClanmatePlatoon +
            this.props.industrialResourceEarnedInRandom +
            this.props.industrialResourceForClanPurchaseProduct +
            this.props.industrialResourceClansupply

        const irTotal = this.props.industrialResourceWhole

        const formattedIndustrial = helpers.thousands(ir)
        const battleModes = ['sortiesMiddle', 'sortiesChampion', 'sortiesAbsolute', 'battles']
        const battleModesCells = battleModes.map(this.renderBattleModeTableCell)

        return (
            <TableRow
                isHoverable
                isActive={this.isRowActive()}
                needPlayHoverSound={this.needPlayHoverSound()}
                onClick={this.props.displayCheckbox ? this.onRowClick : null}
            >
                {this.renderTableCellCheckbox()}
                {this.renderTableCellRole()}
                {this.renderTableCellMember(this.renderExitFromClanButton())}
                {battleModesCells}
                <TableBodyCell
                    valueType={ir ? 'resource' : 'null'}
                    valueWidth="69"
                    isValue
                    tooltipId={irTotal ? 'resource-earned-tooltip' : NotEarnedResourceTooltip.id}
                    tooltipTip={irTotal ? this.props.memberId.toString() : undefined}
                >
                    {formattedIndustrial}
                </TableBodyCell>
                {this.renderTableCellMemberStatus()}
            </TableRow>
        )
    }
}

ClanModesMembersTableItem.propTypes = {
    ...ClanModesMembersTableItem.propTypes,
    sortiesMiddle: PropTypes.number,
    sortiesMiddleWinsPercent: PropTypes.number,
    sortiesChampion: PropTypes.number,
    sortiesChampionWinsPercent: PropTypes.number,
    sortiesAbsolute: PropTypes.number,
    sortiesAbsoluteWinsPercent: PropTypes.number,
    battles: PropTypes.number,
    battlesWinsPercent: PropTypes.number,

    industrialResourceEarnedAsClanmate: PropTypes.number,
    industrialResourceEarnedAsLegionary: PropTypes.number,
    industrialResourceEarnedInRandomInClanmatePlatoon: PropTypes.number,
    industrialResourceEarnedInRandom: PropTypes.number,
    industrialResourceForClanPurchaseProduct: PropTypes.number,
    industrialResourceClansupply: PropTypes.number,

    industrialResourceWhole: PropTypes.number,
}

export default ClanModesMembersTableItem



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/ClanModesMembersTableItem.js